import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["euButton", "usButton", "hint", "banner", "submitButton"]

  selectEu() {
    this.euButtonTarget.classList.remove("c-button--white-inactive")
    this.usButtonTarget.classList.add("c-button--white-inactive")
    this.hintTarget.classList.remove("hidden")
    this.bannerTarget.classList.add("hidden")
    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.classList.remove("c-button--disabled")
  }

  selectUs() {
    this.euButtonTarget.classList.add("c-button--white-inactive")
    this.usButtonTarget.classList.remove("c-button--white-inactive")
    this.hintTarget.classList.add("hidden")
    this.bannerTarget.classList.remove("hidden")
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.classList.add("c-button--disabled")
  }
}
